import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "form-group row mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("h1", null, " My Personal Profile ")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("span", null, " This page displays information about you on file at the Fund Office. You can update this information by clicking on the Update button under the applicable section if any of it has changed. ")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-column justify-content-center"
}
const _hoisted_7 = {
  class: "form-group row mb-4",
  id: "personalInfo"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, " My Personal Information ", -1)
const _hoisted_9 = { class: "col-md-6 mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Participant ID: ", -1)
const _hoisted_11 = { class: "col-md-6 mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Name: ", -1)
const _hoisted_13 = { id: "Name" }
const _hoisted_14 = { class: "col-md-6 mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Date of Birth: ", -1)
const _hoisted_16 = { id: "DateofBirth" }
const _hoisted_17 = { class: "col-md-6 mb-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Gender: ", -1)
const _hoisted_19 = { id: "Gender" }
const _hoisted_20 = { class: "col-md-6 mb-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Marital Status: ", -1)
const _hoisted_22 = { id: "MaritalStatus" }
const _hoisted_23 = { class: "col-md-6 mb-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Home Local: ", -1)
const _hoisted_25 = { id: "HomeLocal" }
const _hoisted_26 = { class: "form-group row mb-4" }
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = { class: "form-group row mb-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, " My Address ", -1)
const _hoisted_30 = { class: "col-md-6 mb-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Address Type: ", -1)
const _hoisted_32 = { class: "col-md-6 mb-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, "Primary: ", -1)
const _hoisted_34 = { class: "col-md-6 mb-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Address: ", -1)
const _hoisted_36 = { class: "col-md-6 mb-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " City: ", -1)
const _hoisted_38 = { class: "col-md-6 mb-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, "State: ", -1)
const _hoisted_40 = { class: "col-md-6 mb-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Country: ", -1)
const _hoisted_42 = { class: "col-md-6 mb-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, "Postal Code: ", -1)
const _hoisted_44 = { class: "form-group row mb-4" }
const _hoisted_45 = { class: "col-md-12" }
const _hoisted_46 = { class: "form-group row mb-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, " My Contact Information ", -1)
const _hoisted_48 = { class: "col-md-6 mb-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Home Phone: ", -1)
const _hoisted_50 = { class: "col-md-6 mb-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, "Mobile Phone: ", -1)
const _hoisted_52 = { class: "col-md-6 mb-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Work Phone: ", -1)
const _hoisted_54 = { class: "col-md-6 mb-4" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " E-mail Address: ", -1)
const _hoisted_56 = { class: "col-md-6 mb-4" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "col-form-label text-md-right fw-bold" }, " Alternate E-mail: ", -1)
const _hoisted_58 = { class: "form-group row mb-4" }
const _hoisted_59 = { class: "col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Loading Data ... "))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString($setup.person?.PersonID), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString($setup.person?.FullName), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString($setup.person?.DateofBirth), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString($setup.person?.Sex), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, _toDisplayString($setup.person?.MaritalStatus), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("span", _hoisted_25, _toDisplayString($setup.person?.HomeLocal), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_router_link, {
                    to: { name: 'personalInformation' },
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(('Update Personal Information')))
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("span", null, _toDisplayString($setup.address?.Type), 1)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("span", null, _toDisplayString($setup.address?.Primary ? 'Yes' : 'No'), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("span", null, _toDisplayString($setup.address?.Address), 1)
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("span", null, _toDisplayString($setup.address?.City), 1)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("span", null, _toDisplayString($setup.address?.State), 1)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("span", null, _toDisplayString($setup.address?.Country), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("span", null, _toDisplayString($setup.address?.ZipCode), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_router_link, {
                    to: { name: 'address' },
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(('Update Primary Address')))
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("span", null, _toDisplayString($setup.contact?.Home), 1)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("span", null, _toDisplayString($setup.contact?.Mobile), 1)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("span", null, _toDisplayString($setup.contact?.Work), 1)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("span", null, _toDisplayString($setup.contact?.Emails?.Primary), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("span", null, _toDisplayString($setup.contact?.Emails?.Secondary), 1)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createVNode(_component_router_link, {
                    to: { name: 'contactInformation' },
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(('Update Contact Information')))
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]))
    ])
  ]))
}